import { compose, pure } from 'recompose';

import LabelUnreadMessage from './labelUnreadMessage';

const enhance = compose(
  pure,
);

export default enhance(LabelUnreadMessage);
